/**
 * Screen-reader-only prefixes for price announcements.
 * Original price is stated first per cognitive flow convention (was X, now Y).
 * Wording matches the Kratos/zappos-ui buildPriceAriaLabel utility.
 */
export const ORIGINAL_PRICE_LABEL = 'Original price was: ';
export const CURRENT_PRICE_LABEL = 'Current price is: ';
